import { render, staticRenderFns } from "./PropertyAlertCreate.vue?vue&type=template&id=5ffca6fe&"
import script from "./PropertyAlertCreate.vue?vue&type=script&lang=js&"
export * from "./PropertyAlertCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports